import PostApi from '@/postApi';
export default {
	namespaced: true,
	state: {
		userData: null,
	},
	actions: {
		async getUserData({
			commit
		},param) {
			let userData = await PostApi.getUserData(param);
			userData = userData?userData.data : null;
			console.log('userData',userData);
			return commit('setUserData', userData);
		},
		async lostAccount({
			commit
		},param) {
			let userData = await PostApi.lostAccount(param);
			// userData = userData?userData.data : null;
			console.log('userData',userData,commit);
			return userData;
		},
		async postSignOut({
			commit
		},param) {
			let logoutData = await PostApi.postSignOut(param);
			console.log('logoutData',logoutData,commit);
			return logoutData;
		},
		async postWxLogin({commit},param) {
			const getWxLoginData = await PostApi.postWxLogin(param);
			console.log('getWxLoginData',commit,getWxLoginData);
			return getWxLoginData;
		},
		async postRedirect({commit},param) {
			const getRedirectData = await PostApi.postRedirect(param);
			console.log('getRedirectData',commit,getRedirectData);
			return getRedirectData;
		},
	},
	mutations: {
		setUserData(state, payload) {
			state.userData = payload;
		},
	},
}
